import { parse } from "date-fns";
export function mutateReview(data) {
    var createdDateTime = (data === null || data === void 0 ? void 0 : data.creation_date) || new Date();
    var createdDate = createdDateTime
        ? parse(createdDateTime, "yyyy-MM-dd", new Date())
        : undefined;
    var review = {
        id: "".concat(createdDateTime, "-").concat(data === null || data === void 0 ? void 0 : data.user_name, "-").concat(data === null || data === void 0 ? void 0 : data.average_rating),
        author: {
            firstName: data === null || data === void 0 ? void 0 : data.user_name,
        },
        rating: data === null || data === void 0 ? void 0 : data.average_rating,
        ratingDescription: data === null || data === void 0 ? void 0 : data.average_rating_description,
        text: data === null || data === void 0 ? void 0 : data.review_text,
        questions: computeReviewQuestions(data),
        reviewedAs: data === null || data === void 0 ? void 0 : data.traveller_type_name,
        createdDateString: createdDate === null || createdDate === void 0 ? void 0 : createdDate.toString(),
    };
    return review;
}
function computeReviewQuestions(data) {
    var questions = [];
    if (data === null || data === void 0 ? void 0 : data.good_description) {
        questions.push({
            question: "What did you like most?", //"pros",
            answer: data === null || data === void 0 ? void 0 : data.good_description,
        });
    }
    if (data.bad_description) {
        questions.push({
            question: "Was there anything you didn't like?", // "cons",
            answer: data === null || data === void 0 ? void 0 : data.bad_description,
        });
    }
    return questions;
}
